<template>
  <div>
    <registration-giftlist-list />
  </div>
</template>
<script>
import registrationGiftlistList from './list.vue'

export default {
  components: {
    registrationGiftlistList
  }
}
</script>
<style>
.filter-container .el-input__inner {
  /* width: 200px !important; */
}
</style>

